// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2aaKP","title":"BackImages_title__3ConF","images":"BackImages_images__1tUUU"};